module.exports = __webpack_public_path__ + "static/fonts/Gotham-Bold.722c5f8.otf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Gotham-Bold.otf
// module id = GKof
// module chunks = 1